import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap"
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';
import '../../components/loader.css';
import { Navigate, useNavigate } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination';

const Customer_plans = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const [plans, setPlans] = useState([]);
    const [features, setFeatures] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showFeatureModal, setShowFeatureModal] = useState(false);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [form, setForm] = useState({ name: "", price: "", description: "" });
    const [featureForm, setFeatureForm] = useState({ name: "", description: "" });
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const navigate = useNavigate();
    
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    
    useEffect(() => { 
        fetchPlans(); 
        fetchFeatures();
    }, []);

    const fetchPlans = async () => {
      const res = await axios.post(`${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/get_plans`,{},{headers: exportValue.headers});
      if (res.data.success) setPlans(res.data.plans);
    };

    const fetchFeatures = async () => {
      const res = await axios.post(`${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/get_features`,{},{headers: exportValue.headers});
      if (res.data.success) setFeatures(res.data.features);
    };
  
    const handleCreate = async () => {
        if (!form.name || !form.price || !form.description) {
          return Swal.fire("Error", "Name, Price, and Description are required", "error");
        }
      
        try {
          const res = await axios.post(
            `${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/create_plans`,
            form,
            { headers: exportValue.headers }
          );
      
          if (res.data.success) {
            Swal.fire("Success", "Plan created successfully", "success");
            setShowModal(false);
            setForm({ name: "", price: "", description: "" });
            fetchPlans();
          } else {
            Swal.fire("Error", "Error creating plan", "error");
          }
        } catch (err) {
          console.error(err);
          Swal.fire("Error", "Something went wrong", "error");
        }
      };

    const handleCreateFeature = async () => {
        if (!featureForm.name) {
          return Swal.fire("Error", "Feature name is required", "error");
        }
      
        try {
          const res = await axios.post(
            `${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/create_feature`,
            featureForm,
            { headers: exportValue.headers }
          );
      
          if (res.data.success) {
            Swal.fire("Success", "Feature created successfully", "success");
            setShowFeatureModal(false);
            setFeatureForm({ name: "", description: "" });
            fetchFeatures();
          } else {
            Swal.fire("Error", "Error creating feature", "error");
          }
        } catch (err) {
          console.error(err);
          Swal.fire("Error", "Something went wrong", "error");
        }
      };

    const handleAssignFeatures = async (plan) => {
        setSelectedPlan(plan);
        try {
            const res = await axios.post(
                `${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/get_plan_features`,
                { plan_id: plan.plan_id },
                { headers: exportValue.headers }
            );
            
            if (res.data.success) {
                const assignedFeatures = res.data.features.map(pf => pf.feature_id._id || pf.feature_id);
                setSelectedFeatures(assignedFeatures);
            }
        } catch (error) {
            console.error("Error fetching plan features:", error);
            setSelectedFeatures([]);
        }
        setShowAssignModal(true);
    };

    const handleSaveFeatures = async () => {
        if (!selectedPlan) return;
        
        try {
            const res = await axios.post(
                `${exportValue.host + "/" + exportValue.version + "/" + exportValue.api}/assign_features_to_plan`,
                { 
                    plan_id: selectedPlan.plan_id, 
                    feature_ids: selectedFeatures 
                },
                { headers: exportValue.headers }
            );
            
            if (res.data.success) {
                Swal.fire("Success", "Features assigned successfully", "success");
                setShowAssignModal(false);
                setSelectedPlan(null);
                setSelectedFeatures([]);
            } else {
                Swal.fire("Error", "Error assigning features", "error");
            }
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Something went wrong", "error");
        }
    };

    const handleFeatureToggle = (featureId) => {
        setSelectedFeatures(prev => 
            prev.includes(featureId)
                ? prev.filter(id => id !== featureId)
                : [...prev, featureId]
        );
    };
  
    const handleDelete = async (plan_id) => {
        Swal.fire({
          title: "Are you sure?",
          text: "Delete plan and unassign from customers?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel"
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const res = await axios.post(
                `${exportValue.host}/${exportValue.version}/${exportValue.api}/remove_plan`,
                { plan_id },
                { headers: exportValue.headers }
              );
      
              if (res.data.success) {
                fetchPlans();
                Swal.fire("Deleted!", "Plan has been deleted.", "success");
              } else {
                Swal.fire("Error", "Delete failed.", "error");
              }
            } catch (err) {
              Swal.fire("Error", err.message, "error");
            }
          }
        });
      };
      
  return (
    <div>
          <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <section class="home-section">
        <Sub_header/>
        <div className=" py-4">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3>Customer Plans</h3>
        <div>
          <button className="btn btn-secondary me-2" onClick={() => setShowFeatureModal(true)}>Add Feature</button>
          <button className="btn btn-primary me-2" onClick={() => setShowModal(true)}>Add Plan</button>
        </div>
      </div>

      {/* Plans Table */}
      <table className="table  table-bordered">
        <thead>
          <tr>
            <th>Plan ID</th>
            <th>Name</th>
            <th>Price</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {plans.map(p => (
            <tr key={p.plan_id}>
              <td>{p.plan_id}</td>
              <td>{p.name}</td>
              <td>{p.price}</td>
              <td>{p.description}</td>
              <td>
                <button className="btn btn-sm btn-info me-2" onClick={() => handleAssignFeatures(p)}>Manage Features</button>
                <button className="btn btn-sm btn-danger me-2" onClick={() => handleDelete(p.plan_id)}>Delete</button>
                <a className="btn btn-sm btn-secondary" href={`/assign_plans/${p.plan_id}`}>Assign Customer</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Add Plan Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header"><h5 className="modal-title">Add Plan</h5></div>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label">Name</label>
                  <input className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Price</label>
                  <input type="number" className="form-control" value={form.price} onChange={e => setForm({...form, price: e.target.value})} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Description</label>
                  <textarea className="form-control" value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleCreate}>Create</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Feature Modal */}
      {showFeatureModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header"><h5 className="modal-title">Add Feature</h5></div>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label">Feature Name</label>
                  <input className="form-control" value={featureForm.name} onChange={e => setFeatureForm({...featureForm, name: e.target.value})} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Description</label>
                  <textarea className="form-control" value={featureForm.description} onChange={e => setFeatureForm({...featureForm, description: e.target.value})} />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowFeatureModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleCreateFeature}>Create</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Assign Features Modal */}
      {showAssignModal && selectedPlan && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Manage Features for {selectedPlan.name}</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  {features.map(feature => (
                    <div className="col-md-6 mb-3" key={feature._id}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedFeatures.includes(feature._id)}
                          onChange={() => handleFeatureToggle(feature._id)}
                          id={`feature-${feature._id}`}
                        />
                        <label className="form-check-label" htmlFor={`feature-${feature._id}`}>
                          <strong>{feature.name}</strong>
                          {feature.description && <small className="d-block text-muted">{feature.description}</small>}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                {features.length === 0 && (
                  <div className="text-center py-3">
                    <p>No features found. <a href="#" onClick={() => { setShowAssignModal(false); setShowFeatureModal(true); }}>Create some features first</a>.</p>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAssignModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleSaveFeatures} disabled={features.length === 0}>Save Features</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
    
       </section>
      
    </div>
  )
}

export default Customer_plans